import React from 'react';
import { Radar } from 'react-chartjs-2';

import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
}  from 'chart.js';


ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

export const defaultRadarOptions = {
  legend:{
    display: false,
  },
  scales: {
      r:{
        beginAtZero: true,
        min:  0,
        max:  4,
      },
    }
};


export const sampleRadarData = {
    labels: [
      'Growth',
      'Valuation',
      'Profitability',
      'Strength',
      'Sentiment',
      'Momentum'
    ],
    datasets: [{
      label: 'Quants',
      data: [11, 16, 70, 38, 14, 44],
      backgroundColor:  'rgba(94, 124, 235, 0.7)'
    }]
  };

  export const  RadarChart = ({chartData}, {chartOptions}) => {
    return (
      <div>
        <Radar data={chartData} options={chartOptions} height="260px"/>
      </div>
    );
  };